import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommitmentsGridPart } from '../../../../../ui/widget/shared-grids/commitments-grid/commitments-grid.part';
import { ConfigurationAreaService } from '../../../configuration-area.service';
import { ConfigurationCommitmentsService } from '../../configuration-commitments.service';

@Component({
	selector: 'configuration-commitments-commitments-view-part',
	standalone: true,
	imports: [CommitmentsGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './commitments-view.part.html',
})
export class ConfigurationCommitmentsCommitmentsViewPart {

	private readonly areaService = inject(ConfigurationAreaService);
	public readonly pageService = inject(ConfigurationCommitmentsService);
	
	public commitments = computed(() => {
		const data = this.areaService.configurationData();
		return data?.commitments ?? [];
	});

}